import { onClosePopUp } from "redux/slices";
import useBreakpoints from "hooks/useBreakpoints";
import { useAppDispatch, useImagePath } from "hooks";
import { Avatar, Button, Container, Header, Title } from "./styles";
import { dailyGiftAssets } from "assets/cdn";

interface DailyRewardStreakBreakProps {}

export const DailyRewardStreakBreak: React.FC<
	DailyRewardStreakBreakProps
> = () => {
	const dispatch = useAppDispatch();
	const { isSmDown } = useBreakpoints();
	const { getImage } = useImagePath("cdn");
	const { streakBreak } = dailyGiftAssets.popups;
	const headImageUrl = getImage(streakBreak.background);
	const avatarUrl = getImage(streakBreak.poi);
	const titleUrl = getImage(streakBreak.title);
	const mobileHeadImageUrl = getImage(streakBreak.backgroundMobile);
	const mobileAvatarUrl = getImage(streakBreak.poiMobile);
	const mobileTitleUrl = getImage(streakBreak.titleMobile);

	return (
		<Container>
			<Header data-image={isSmDown ? mobileHeadImageUrl : headImageUrl}>
				<Avatar src={isSmDown ? mobileAvatarUrl : avatarUrl} />
				<Title src={isSmDown ? mobileTitleUrl : titleUrl} />
				<Button
					variant="contained"
					themeColor="secondary"
					onClick={() => dispatch(onClosePopUp())}
				>
					Continue Shopping
				</Button>
			</Header>
		</Container>
	);
};
